import { breakpoints, colors } from 'style'
import styled from 'styled-components'

export const AboutUsContainer = styled.div`
  background-color: ${colors.white};

  .section {
  }
  .section:nth-child(even) {
    background: #ece6e0;
    .container {
      background-color: #ece6e0;
    }
  }

  @media (max-width: ${breakpoints.sm}px) {
    h2 {
      margin: 0 1rem;
    }

    h4 {
      margin: 0 1rem;
    }

    img {
      padding: 0 1rem;
    }
  }
`
